export default __webpack_public_path__ + "static/media/sportsSee_logo.b16f87db.svg";